module.exports = __webpack_public_path__ + "static/media/edian-reyes-transparent.8a6f6132.png";